/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who4_DescInputs */

const en_dr_who4_desc = /** @type {(inputs: Dr_Who4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run every workshop for a client through the same disciplined six steps, then hand each one a branded PDF report and a certificate — without building your own tool.`)
};

const id_dr_who4_desc = /** @type {(inputs: Dr_Who4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalankan tiap workshop klien dengan enam langkah disiplin yang sama, lalu serahkan laporan PDF berbranding dan sertifikat — tanpa membangun alat sendiri.`)
};

/**
* | output |
* | --- |
* | "Run every workshop for a client through the same disciplined six steps, then hand each one a branded PDF report and a certificate — without building your own..." |
*
* @param {Dr_Who4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who4_desc = /** @type {((inputs?: Dr_Who4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who4_desc(inputs)
	return en_dr_who4_desc(inputs)
});